import { useEffect } from 'react';
import { activeComposition } from '../core/project';
import { audioEngine } from '../services/audioEngine';
import { useEditorStore } from '../store/editorStore';
import { startPlaybackClock, usePlaybackStore } from '../store/playbackStore';

export function usePlaybackClock() {
  useEffect(() => startPlaybackClock(
    () => activeComposition(useEditorStore.getState().project).duration,
    () => void audioEngine.play(useEditorStore.getState().project, usePlaybackStore.getState().currentTime),
    () => audioEngine.stop()
  ), []);
}
